import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AutoBatchSerialCreationComponent } from '../auto-batch-serial-creation/auto-batch-serial-creation.component';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { BatchAddModel } from 'src/app/core/models/masters/batch-add.model';
import { SerialAddModel } from 'src/app/core/models/masters/serial-add.model';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-batch-serial-add-popup',
  templateUrl: './batch-serial-add-popup.component.html',
  styleUrls: ['./batch-serial-add-popup.component.css']
})
export class BatchSerialAddPopupComponent extends GenericListView<any> implements OnInit {
  // DataSource = new MatTableDataSource<BatchAddModel | SerialAddModel>();
  batchItemRows: BatchAddModel[] = [];
  serialItemRows: SerialAddModel[] = [];
  batchDisplayedColumns = ['serialNo', 'BatchNo', 'Quantity', 'BatchAttribute1', 'BatchAttribute2', 'BinLocationAllocation', 'ExpirationDate', 'MfrDate', 'AdmissionDate'];
  serialDisplayedColumns = ['serialNo', 'ManufSerialNumber', 'InteSerialNumber', 'lotNum', 'binLocation', 'Expirydate', 'manufDate', 'admDate', 'warrantyStart', 'warrantyEnd', 'SysNumber'];
  local_data: any;
  isBatch = true;
  constructor(agenericRepository: GenericService<any>, router: Router, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>,
    public snackbarService: BaseService<any>) {
    super(agenericRepository, router);
    if (data.data) { this.local_data = data.data; }
    else {
      this.local_data = data
    }
    console.log(' this.local_data', this.local_data)
    this.isBatch = this.local_data.manageBatchNumbers == "Y";
    if (data.component != "InventoryPosting" || data.component == "" || data.component == "undefined") {
      if (this.local_data.isSerialed) {
        //    this.local_data.serialNumbers = this.convertCamelToPascal(this.local_data.serialNumbers);
        this.serialItemRows = JSON.parse(JSON.stringify(this.local_data.serialNumbers));
      } else if (this.local_data.isBatched) {
        console.log(this.local_data.batchNumbers);
        //  this.local_data.batchNumbers = this.convertCamelToPascal(this.local_data.batchNumbers);
        this.batchItemRows = JSON.parse(JSON.stringify(this.local_data.batchNumbers.map((item: any) => ({
          ...item,
          batchNumberProperty: item.batchNumber
        }))));
      }
    } else if (data.component == "InventoryPosting") {
      if (this.local_data.isSerialed) {
        //   this.local_data.serialNumbers = this.convertCamelToPascal(this.local_data.inventoryPostingSerialNumbers);
        this.serialItemRows = JSON.parse(JSON.stringify(this.local_data.serialNumbers));
      } else if (this.local_data.isBatched) {
        console.log(this.local_data.batchNumbers);
        //   this.local_data.batchNumbers = this.convertCamelToPascal(this.local_data.inventoryPostingBatchNumbers);
        this.batchItemRows = JSON.parse(JSON.stringify(this.local_data.batchNumbers.map((item: any) => ({
          ...item,
          batchNumberProperty: item.batchNumber
        }))));
      }
    }
  }

  ngOnInit(): void {
    // set batch serial initial rows
    if (!this.local_data.isViewMode) {
      for (let i = 0; i < 3; i++) {
        if (this.isBatch) {
          this.batchItemRows.push(new BatchAddModel())
        } else {
          this.serialItemRows.push(new SerialAddModel())
        }
      }
    }
  }

  showAutoRowCreationPopup() {
    this.dialog.open(AutoBatchSerialCreationComponent, {
      data: this.local_data,
      height: "100%"
    }).afterClosed().subscribe((res) => {
      let autoStringCreationArr = res.autoStringCreation;
      if (this.isBatch) {
        const batchItemResponse: BatchAddModel = res.value;
        console.log(batchItemResponse);
        let batchItemList: BatchAddModel[] = [];
        for (let i = 0; i < batchItemResponse.numOfBatch; i++) {
          let batchItem = new BatchAddModel();
          batchItem.quantity = +(this.local_data.quantity / batchItemResponse.numOfBatch).toFixed(2);

          batchItem.batchNumberProperty = getCreation(0) ? getCreationString(0) +
            automateNumber(0, i) : batchItemResponse.batchNumber;

          batchItem.internalSerialNumber = getCreation(1) ? getCreationString(1) +
            automateNumber(1, i) : batchItemResponse.internalSerialNumber;

          batchItem.manufacturerSerialNumber = getCreation(2) ? getCreationString(2) +
            automateNumber(2, i) : batchItemResponse.manufacturerSerialNumber;

          batchItem.binLocationValue = batchItemResponse.binLocationValue;
          batchItem.expiryDate = batchItemResponse.expiryDate;
          batchItem.manufacturingDate = batchItemResponse.manufacturingDate;
          batchItem.addmisionDate = batchItemResponse.addmisionDate;
          batchItemList.push(batchItem);
        }
        this.batchItemRows = [...batchItemList];
      } else {
        const serialItemResponse: SerialAddModel = res.value;
        let serialItemList: SerialAddModel[] = [];

        for (let i = 0; i < this.local_data.quantity; i++) {
          let serialItem = new SerialAddModel();

          serialItem.manufacturerSerialNumber = getCreation(0) ? getCreationString(0) +
            automateNumber(0, i) : serialItemResponse.manufacturerSerialNumber;

          serialItem.internalSerialNumber = getCreation(1) ? getCreationString(1) +
            automateNumber(1, i) : serialItemResponse.internalSerialNumber;

          serialItem.batchID = getCreation(2) ? getCreationString(2) +
            automateNumber(2, i) : serialItemResponse.batchID;

          serialItem.expiryDate = serialItemResponse.expiryDate;
          serialItem.manufactureDate = serialItemResponse.manufactureDate;
          serialItem.receptionDate = serialItemResponse.receptionDate;
          serialItem.warrantyStart = serialItemResponse.warrantyStart;
          serialItem.warrantyEnd = serialItemResponse.warrantyEnd;
          serialItemList.push(serialItem);
        }

        this.serialItemRows = [...serialItemList];
      }

      function getCreation(type: number) {
        return autoStringCreationArr.find((el: any) => el.type == type);
      }

      function getCreationString(type: number) {
        return getCreation(type).criteria.find((el: any) => el.type == 'string').text;
      }

      function getCreationNumber(type: number) {
        return getCreation(type).criteria.find((el: any) => el.type == 'number').text;
      }

      function getCreationOperation(type: number) {
        return getCreation(type).criteria.find((el: any) => el.type == 'number').operation;
      }

      function automateNumber(type: any, i: number) {
        return eval(`${getCreationNumber(type)} ${getCreationOperation(type)} ${i}`)
      }
    });
  }

  validateBatchFields() {
    return this.filledBatchRows.every(item => item.quantity);
  }

  validateSerialFields() {
    return this.filledSerialRows.every(item => item.manufacturerSerialNumber && item.internalSerialNumber)
      && (this.filledSerialRows.length == this.local_data.quantity);
  }

  enterQuantity(qtyEl: any, i: number) {
    qtyEl.value = qtyEl.value < 1 ? "" : qtyEl.value;
    if (this.totalEnteredQty > this.local_data.quantity) {
      this.snackbarService.showMessage("Batch Quantity Can not be more than GRPO quantity", "X");
      if (this.isBatch) {
        this.batchItemRows[i].quantity = null;
      } else {
        this.serialItemRows[i].quantity = null;
      }
      qtyEl.value = "";
    }
  }

  checkDuplicateEntries(fields: any[], itemRows: any[]) {
    let duplicateFileds: any = []
    fields.forEach((field: string) => {
      let values = itemRows.filter(item => { return item[field] }).map(el => el[field]);
      let unique = new Set(values);
      if (values.length !== unique.size) {
        duplicateFileds.push(field);
      }
    })
    return duplicateFileds;
  }

  addItemRow() {
    if (this.isBatch) {
    //  this.batchItemRows.push(new BatchAddModel())
      this.batchItemRows = [...this.batchItemRows, new BatchAddModel()];
      console.log(this.batchItemRows)
    } else {
      //this.serialItemRows.push(new SerialAddModel());
      this.serialItemRows = [...this.serialItemRows, new SerialAddModel()];
    }
  }
  syncBatchNumber(element: any) {
    element.batchNumber = element.batchNumberProperty;
  }

  get filledBatchRows(): BatchAddModel[] {
    return this.batchItemRows.filter((item: any) => item.batchNumberProperty);
  }

  get filledSerialRows(): SerialAddModel[] {
    return this.serialItemRows
    .filter((item: any) => item.internalSerialNumber || item.manufacturerSerialNumber)// Filter items with quantity > 0
    .map((item: any) => ({
      ...item, // Keep existing properties if needed
      quantity: 1,
    
      // Ensure negative value for fromWarehouseQty
    }));
    
   }

   get totalEnteredQty() {
  if (this.isBatch) {
    return this.batchItemRows.reduce((sum, item) => sum + (item.quantity || 0), 0)
  } else {
    return this.serialItemRows.reduce((sum, item) => sum + (item.quantity || 0), 0)
  }
}

addBatchSerial() {
    var pipe = new DatePipe('en-US');
  console.log(this.batchItemRows); 
  if (this.isBatch) {
    if (this.validateBatchFields()) {
      let validateFields = ['batchNumberProperty', 'internalSerialNumber', 'manufacturerSerialNumber'];
      const duplicateEntries = this.checkDuplicateEntries(validateFields, this.filledBatchRows);

      if (duplicateEntries.length > 0) {
        this.snackbarService.showMessage(`Duplicate entries found in ${duplicateEntries.join(', ')}`, "X");
      } else {
        this.filledBatchRows.forEach((item, i) => {
          console.log('item',item)
          this.filledBatchRows[i].itemCode = this.local_data.itemCode;
          this.filledBatchRows[i].addmisionDate = pipe.transform(item.addmisionDate, 'y-MM-d')
        })
        if (this.totalEnteredQty == this.local_data.quantity) {
          this.dialogRef.close({ event: true, value: this.filledBatchRows });
        } else {
          this.snackbarService.showMessage("Please Use All the Quantity", "X");
        }
      }
    }
  } else {
    if (this.validateSerialFields()) {
      let validateFields = ['manufacturerSerialNumber', 'internalSerialNumber', 'batchID'];
      const duplicateEntries = this.checkDuplicateEntries(validateFields, this.filledSerialRows);

      if (duplicateEntries.length > 0) {
        this.snackbarService.showMessage(`Duplicate entries found in ${duplicateEntries.join(', ')}`, "X");
      } else {
        this.filledSerialRows.forEach((item, i) => {
          this.filledSerialRows[i].itemCode = this.local_data.itemCode;
          //this.filledBatchRows[i].addmisionDate = pipe.transform(this.local_data.addmisionDate, 'y-MM-d')
        })
        this.dialogRef.close({ event: true, value: this.filledSerialRows });
      }
    } else {
      this.snackbarService.showMessage("Please fill all mandatory fields", "X");
    }
  }
}

toPascalCase(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

convertCamelToPascal(obj: any) {
  if (!obj || typeof obj !== "object") return obj;

  // If it's a Date object, return it directly without modification
  if (obj instanceof Date) return obj;

  const newObject: any = Array.isArray(obj) ? [] : {};

  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const pascalKey = this.toPascalCase(key);
      newObject[pascalKey] = this.convertCamelToPascal(obj[key]);
    }
  }
  return newObject;
}


}
